import qs from 'qs';

/**
 * 경로와 쿼리 파라미터를 병합한 URL을 생성합니다.
 * @description
 * - 기본 경로에 이미 쿼리가 있는 경우 그대로 반환합니다.
 * - 쿼리가 없는 경우 직렬화된 파라미터를 추가합니다.
 * - OpenStack API에서 사용하는 repeat 형식(`foo=a&foo=b`)을 기본 arrayFormat으로 적용합니다.
 * @example
 * // mergePathWithQuery('/settings/account', { lang: 'ko' })
 */
export const mergePathWithQuery = (
  basePath: string,
  query: qs.ParsedQs,
  options?: qs.IStringifyOptions,
): string => {
  if (!basePath) return basePath;
  if (basePath.includes('?')) return basePath;

  const suffix = qs.stringify(query, {
    addQueryPrefix: true,
    skipNulls: true,
    arrayFormat: 'repeat',
    ...options,
  });

  return `${basePath}${suffix}`;
};
